// extracted by mini-css-extract-plugin
export default {"label":"ta_label__AsIO2","txarea":"ta_txarea__Kyam3"};